/* THE CART DOWNSELL (owner, 2026-10-31) — loaded only when the cart offer rows render.
 *
 * The server renders the offer rows and, hidden, the two cheapest decor pieces not in
 * the cart. `data-rz-decor` on the section lists the decor pieces in the cart. Between
 * two renders, a piece that left that list was removed by the shopper: the rows give
 * way to ONE cheaper piece that is not the one removed. Adding any decor piece ends it.
 *
 * Horizon re-renders the cart section on every change, so the state lives in
 * sessionStorage and is re-applied after each render (a MutationObserver, batched to
 * one animation frame and disconnected while it writes, so it never feeds itself).
 */
(function () {
  'use strict';
  if (window.__rzOffer) return;
  window.__rzOffer = true;

  var PREV = 'rz_decor_prev';
  var FROM = 'rz_downsell_from';

  function get(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function set(k, v) {
    try { if (v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v); } catch (e) { /* private mode */ }
  }
  function list(s) { return (s || '').split(',').filter(Boolean); }

  function apply(el) {
    var now = list(el.getAttribute('data-rz-decor'));
    var prevRaw = get(PREV);
    if (prevRaw !== null) {
      var prev = list(prevRaw);
      var added = now.filter(function (h) { return prev.indexOf(h) < 0; });
      var removed = prev.filter(function (h) { return now.indexOf(h) < 0; });
      if (added.length) set(FROM, null);
      else if (removed.length) set(FROM, removed[0]);
    }
    set(PREV, now.join(','));

    var from = get(FROM);
    var rows = el.querySelectorAll('[data-rz-kind="row"]');
    var downs = el.querySelectorAll('[data-rz-kind="down"]');
    var pick = null;
    if (from) {
      for (var i = 0; i < downs.length; i++) {
        if (downs[i].getAttribute('data-handle') !== from) { pick = downs[i]; break; }
      }
    }
    var head = el.querySelector('[data-rz-offer-heading]');
    if (head && !head.hasAttribute('data-up')) head.setAttribute('data-up', head.textContent);
    rows.forEach(function (r) { r.hidden = !!pick; });
    downs.forEach(function (d) { d.hidden = d !== pick; });
    if (head) head.textContent = pick ? head.getAttribute('data-down') : head.getAttribute('data-up');
    el.hidden = !pick && rows.length === 0;
  }

  var pending = false;
  var mo = new MutationObserver(schedule);
  function watch() {
    /* only the cart's own containers re-render the rows; the whole page is the fallback */
    var roots = document.querySelectorAll('cart-items-component');
    if (!roots.length) roots = [document.body];
    for (var i = 0; i < roots.length; i++) {
      mo.observe(roots[i], { subtree: true, childList: true, attributes: true, attributeFilter: ['data-rz-decor'] });
    }
  }
  function run() {
    pending = false;
    mo.disconnect();
    document.querySelectorAll('[data-rz-offer]').forEach(function (el) {
      if (!el.classList.contains('rz-offer--pdp')) apply(el);
    });
    watch();
  }
  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(run);
  }

  run();
})();
